import { Stack, Typography } from "@mui/material";
import {
  H1,
  H3,
  P_REGULAR,
  SECONDARY_MAIN,
} from "../../../Constants/CommonConstants";
import {
  ACCOUNT_TYPE_SITE_CERTIFIER,
  PROVIDER_REVIEW_CERTIFIER_SUB_TEXT,
  PROVIDER_REVIEW_STAFF_SUB_TEXT,
  PROVIDER_SITE_INFO_REVIEW_HEADING,
} from "../../../Constants/ProviderAndCertifierAccountCreationConstants";
import { useSelector } from "react-redux";
import { manageProviderAccountCreationSelector } from "../../../Selectors/ProviderAccountCreationSelector";
import { manageReferenceDataSelector } from "../../../Selectors/ReferenceDataSelector";
import { useMemo } from "react";
import { fetchUserRoleByValue } from "../../../Services/CommonServices";
import { useIntl } from "react-intl";

/**
 * @description Provider Review Information Header and subtext component that renders the header and subtext
 * @returns {ReactNode} React component consisting of heading and subtext for Provider Review Information.
 */
const ProviderReviewInfoHeaderAndSubtext = () => {
  const intl = useIntl();

  const { accountType } = useSelector((state) =>
    manageProviderAccountCreationSelector(state)
  );

  const { userRole } = useSelector((state) =>
    manageReferenceDataSelector(state)
  );

  const userRoleValue = useMemo(() => {
    return fetchUserRoleByValue(userRole, accountType);
  }, [accountType, userRole]);

  const subtext =
    userRoleValue?.valueText === ACCOUNT_TYPE_SITE_CERTIFIER
      ? PROVIDER_REVIEW_CERTIFIER_SUB_TEXT
      : PROVIDER_REVIEW_STAFF_SUB_TEXT;
  return (
    <Stack spacing={3}>
      <Typography
        component={H1}
        variant={H3}
        color={SECONDARY_MAIN}
        id={PROVIDER_SITE_INFO_REVIEW_HEADING}
      >
        {intl.formatMessage({ id: PROVIDER_SITE_INFO_REVIEW_HEADING })}
      </Typography>
      <Typography variant={P_REGULAR} id={subtext}>
        {intl.formatMessage({
          id: subtext,
        })}
      </Typography>
    </Stack>
  );
};

export default ProviderReviewInfoHeaderAndSubtext;
